module.exports = __webpack_public_path__ + "static/img/miyu.b506b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/miyu.png
// module id = gnrg
// module chunks = 24